export default __webpack_public_path__ + "static/media/lh.1a6c1581.png";